// Custom CSS
import './assets/scss/styles.scss'

// External JS 
import * as bootstrap from 'bootstrap'

// Custom JS
/* import './assets/js/transition' */
import './assets/js/lenis'
import './assets/js/swiper'
import './assets/js/content-timeline'
import './assets/js/newsletter'
import './assets/js/figures'
import './assets/js/events'

/* Nav */
const hamburgerToggle = document.querySelector('.hamburger-toggle');
const navbarContent = document.querySelector('#navbar-content');

navbarContent.addEventListener('show.bs.collapse', () => {
    hamburgerToggle.classList.add('active');
})

navbarContent.addEventListener('hide.bs.collapse', () => {
    hamburgerToggle.classList.remove('active');
})


/* Tooltips */
const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    
if (tooltipTriggerList.length > 0) {
    tooltipTriggerList.map(tooltip => {
        // console.log(tooltip);
        new bootstrap.Tooltip(tooltip)
    });
}

